import script from "./InterviewForm.vue?vue&type=script&setup=true&lang=js"
export * from "./InterviewForm.vue?vue&type=script&setup=true&lang=js"

export default script